export default {
  ACTIONACTOR_CONTAINER: 'ACTIONACTOR_CONTAINER',
  ACTIONACTOR_IMAGE: 'ACTIONACTOR_IMAGE',
  ACTIONACTOR_DESELECT_CLICK: 'ACTIONACTOR_DESELECT_CLICK',
  
  ACTOR_CONTAINER: 'ACTOR_CONTAINER',
  ACTOR_IMAGE: 'ACTOR_IMAGE',
  ACTOR_NAME_TEXT: 'ACTOR_NAME_TEXT',
  ACTOR_DESIGNATION_TEXT: 'ACTOR_DESIGNATION_TEXT',
  ACTOR_LOCK_ICON: 'ACTOR_LOCK_ICON',
  ACTOR_HOVER_MESSAGE_TEXT: 'ACTOR_HOVER_MESSAGE_TEXT',
  
  ACTORMETRIC_CONTAINER: 'ACTORMETRIC_CONTAINER',
  ACTORMETRIC_VALUE_TEXT: 'ACTORMETRIC_VALUE_TEXT',
  ACTORMETRIC_NAME_TEXT: 'ACTORMETRIC_NAME_TEXT',
  ACTORMETRIC_CHANGE_TEXT: 'ACTORMETRIC_CHANGE_TEXT',
  
  ACTORSBOX_CONTAINER: 'ACTORSBOX_CONTAINER',
  ACTORSBOX_HEADING_TEXT: 'ACTORSBOX_HEADING_TEXT',
  
  IMPACTACTOR_CONTAINER: 'IMPACTACTOR_CONTAINER',
  IMPACTACTOR_IMAGE: 'IMPACTACTOR_IMAGE',
  IMPACTACTOR_NAME_TEXT: 'IMPACTACTOR_NAME_TEXT',
  IMPACTACTOR_CHANGE_TEXT: 'IMPACTACTOR_CHANGE_TEXT',
};



